<template>
  <WizardPage
    v-if="shouldRender"
    hide-button-back
    hide-button-forward
    :step="step"
    class="text-center">
    <img
      class="text-center"
      src="@/assets/customer-image-vivantes.png">
    <div
      class="text-center body-1">
      Vielen Dank für Ihre Bewerbung. Wir werden uns umgehend bei Ihnen melden.
    </div>
  </WizardPage>
</template>

<script>
import WizardPage from './WizardPage'
import WizardPageMixin from './../mixins/WizardPageMixin'

export default {
  name: 'WizardPageGoodBye',

  components: {
    WizardPage
  },

  mixins: [
    WizardPageMixin
  ]
}
</script>
